import { defineAsyncComponent } from 'vue';

export default {
    'reveal-menu': defineAsyncComponent({ loader: () => import('./Components/RevealMenu/RevealMenu') }),
    'carousel-images': defineAsyncComponent({ loader: () => import('./Components/Carousel/Carousel') }),
    'modal': defineAsyncComponent({ loader: () => import('./Components/Modal/Modal') }),
    'vue-image': defineAsyncComponent(() => import('./Components/Images/VueImage')),
    'vue-bg-image': defineAsyncComponent(() => import('./Components/Images/VueBackgroundImage')),
};
